export default "__VITE_ASSET__Cpq5zySP__"